<template>
  <div>
    <form data-vv-scope="step-2-part-1">
      <div class="row mb-5">
        <div class="col-12">
          <h4>Datos de la persona que ingresa el documento</h4>
        </div>
        <div class="col-md-12">
          <list-user-groups
            class="w-100"
            autocomplete
            only-groups
            label="Grupo al que irá asociado el expediente (*)"
            name="creatorGroup"
            v-model="step.creatorGroup"
            :danger="errors.has('step-2-part-1.creatorGroup')"
            :danger-text="errors.first('step-2-part-1.creatorGroup')"
            v-validate="{ required: userGroupsState.list.length > 1 }"
            ref="creatorGroup"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <h4>Origen / Datos Remitente</h4>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-input
            class="w-100"
            label="Cargo Persona (*)"
            maxlength="150"
            name="personPosition"
            v-validate="'required'"
            data-vv-as="cargo persona"
            :danger="errors.has('step-2-part-1.personPosition')"
            :danger-text="errors.first('step-2-part-1.personPosition')"
            v-model="step.personPosition"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="step-2-part-2">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Destinatario (*)</h4>
        </div>
      </div>
      <SelectSubject
        :docTypeSelected="documentTypeSelected"
        @add-subject="addSubject"
        @clear-sanitaries="clearSanitaries"
        @clear-doc-digital="clearDocDigital"
      />
      <div class="row mb-3">
        <div class="col-12">
          <TableSubjects
            :subjects="step.subjects"
            v-model="step.subjectsSelected"
            @clear-doc-digital="clearDocDigital"
          />
        </div>
      </div>
    </form>
    <div class="row mb-3">
      <div class="col-12">
        <vs-divider />
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import ListUserGroups from '@/febos/chile/lists/components/ListUserGroups';
import SelectSubject from '@/febos/chile/dnt/components/wizard/companies/61221000-4/components/SelectSubject';
import TableSubjects from '@/febos/chile/dnt/components/wizard/subjects/TableSubjects';

export default {
  mixins: [WizardStep],
  components: {
    ListUserGroups,
    SelectSubject,
    TableSubjects
  },
  data() {
    return {
      error: {
        message: ''
      },
      listType: 1,
      emailRequired: ['personas', 'empresas', 'ministerios'],
      isInput: ['personas', 'empresas'],
      subjectForm: {
        subjectType: '',
        subject: '',
        subjectTypeDigitalDoc: '',
        subjectEmail: '',
      },
      copySubjectForm: {
        copySubjectType: '',
        copySubject: '',
        copySubjectTypeDigitalDoc: '',
        copySubjectEmail: '',
      },
      step: {
        responseFile: false,
        creatorGroup: '',
        directionId: '',
        personId: '',
        personPosition: '',
        withAttachment: 0,
        documentDetail: '',
        resumen: '',
        observation: '',
        subjects: [],
        copies: [],
        subjectsSelected: [],
        copiesSelected: [],
        ...this.draft
      }
    };
  },
  watch: {
    subjects(newValue) {
      this.subjectsSelected = newValue;
      this.subjects = newValue;
    },
    copies(newValue) {
      this.copiesSelected = newValue;
      this.copies = newValue;
    }
  },
  computed: {
    ...mapGetters('List', [
      'userGroupsState'
    ]),
    ...mapGetters('Dnts', [
      'wizardData',
      'documentTypeSelected'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ])
  },
  methods: {
    setPosition(user) {
      this.step.personPosition = user.position || '';
    },
    clearSanitaries() {
      this.step.subjects = this.step.subjects
        .filter((subject) => subject.subjectType.value !== 'sanitarias');
      this.step.subjectsSelected = this.step.subjectsSelected
        .filter((subject) => subject.subjectType.value !== 'sanitarias');
    },
    async addSubject(row) {
      if (row.subject.id === this.currentUser.id) {
        this.$bvToast.toast(
          'No te puedes agregar como destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }
      const isSelected = this.step.subjectsSelected
        .some((subjectRow) => {
          if (subjectRow.subjectType.value === 'docDigital') return subjectRow.subjectTypeDigitalDoc.id === row.subjectTypeDigitalDoc.id;

          return subjectRow.subject.id === row.subject.id;
        });

      if (!isSelected || row.allowMultipleTimes) {
        this.step.subjects.push(row);
        this.step.subjectsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste este destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    async addCopy(row) {
      if (row.copySubject.id === this.currentUser.id) {
        this.$bvToast.toast(
          'No te puedes agregar como copia',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }
      const isSelected = this.step.copiesSelected
        .some((copyRow) => {
          if (copyRow.copySubjectType.value === 'docDigital') return copyRow.copySubjectTypeDigitalDoc.id === row.copySubjectTypeDigitalDoc.id;

          return copyRow.copySubject.id === row.copySubject.id;
        });
      if (!isSelected || row.allowMultipleTimes) {
        this.step.copies.push(row);
        this.step.copiesSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste esta copia',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    async isValid() {
      const stepValidations = await Promise.all([
        this.validateForm('step-2-part-1'),
        this.validateForm('step-2-part-4'),
      ]);

      if (stepValidations.some((step) => !step)) {
        return false;
      }

      if (!this.step.subjectsSelected.length) {
        this.error.message = 'Debes agregar al menos un destino';
        return false;
      }

      return true;
    },
    getStepData() {
      const directionName = this.step.directionId
        ? {
          directionName: this.$refs.directionId.getOption().label
        }
        : {};

      const personName = this.step.personId
        ? {
          personName: this.$refs.personName.getOption().label
        }
        : {};

      const creatorGroupName = this.step.creatorGroup
        ? {
          creatorGroupName: this.$refs.creatorGroup.getOption().label
        }
        : {};

      return {
        ...this.step,
        ...directionName,
        ...personName,
        ...creatorGroupName
      };
    },
    clearDocDigital() {
      this.subjects = this.subjects
        .filter((subject) => subject.subjectType.value !== 'docDigital');
      this.subjectsSelected = this.subjectsSelected
        .filter((subject) => subject.subjectType.value !== 'docDigital');
    },
    clearCopiesDocDigital() {
      this.copies = this.copies
        .filter((copies) => copies.copySubjectType.value !== 'docDigital');
      this.copiesSelected = this.copiesSelected
        .filter((copies) => copies.copySubjectType.value !== 'docDigital');
    }
  },
  created() {
    if (this.userGroupsState.list.length === 1) {
      this.step.creatorGroup = this.userGroupsState.list[0].id;
      this.step.creatorGroupName = this.userGroupsState.list[0].label;
    }
    // Esto se usa desde un principio como descripción de flujo, no borrar
    this.step.resumen = (this.wizardData.matter || '').slice(0, 50);
  }
};

</script>
